import { render } from "./ShareIcon.vue?vue&type=template&id=397963e8"
import script from "./ShareIcon.vue?vue&type=script&lang=js"
export * from "./ShareIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/deployments/control-center.conneqt.io/new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__